import React from 'react'
// import { Link } from 'react-router-dom'


// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as SHARED_ACTION from '@store/shared/actions'


import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'

import MaskedInput from 'react-text-mask'

import $ from 'jquery'

import { handleBlurDatalayer } from '@helpers/BI'

import { Icon } from '@components/shared/elements'

class Newsletter extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: false,
      success: false,
      name: '',
      email: '',
      phone: '',
      nameDirt: false,
      nameControl: false,
      emailDirt: false,
      emailControl: false,
      phoneDirt: false,
      phoneControl: false,
      warningWhatsapp: false,
      hasEmail: false,
      praca: '',
      privacyPolicies: true,
    }
    // this.el = React.createRef();
  }

  _handleSubmit(event) {
    event.preventDefault()

    let region = this.props.region
    let state = this.props.regions.estados
    let getState = state.find(x => x.IdEstado === region).Uf.toLowerCase()
    const gaSend = COOKIES.getUtmGaSend()

    let payload = {
      Nome: this.state.name,
      Email: this.state.email,
      Telefone: this.state.phone,
      SerAvisadoPorWhatsApp: this.state.warningWhatsapp,
      Praca: getState,
    }

    Object.assign(payload, gaSend)

    this.setState({
      loading: true,
      success: false,
      error: false,
      hasEmail: false,
    })

    // if (getState) {
    //   this.setState({
    //     praca: getState,
    //   })
    // }

    this.props.actions.subscribeNewsLetter(payload).then((response) => {
      this.setState({
        loading: false,
        success: true,
        name: '',
        email: '',
        phone: '',
        nameDirt: false,
        emailDirt: false,
        phoneDirt: false,
        warningWhatsapp: false,
        praca: '',
        privacyPolicies: true,
      })

      if (response.repetido) {
        this.setState({
          hasEmail: true,
        })
      }

      // GA data
      let dataLayer = window['dataLayer']
      if (dataLayer) {
        dataLayer.push({ 'event': 'clickEvent', 'eventCategory': 'form-cadastro', 'eventAction': 'newsletter:submit', 'eventLabel': `newletter-novidades:${response.IdLead}`, 'leadID': `${response.IdLead}` })
      }

      // hides message after 5 seconds
      $('#successModalNewsletter').foundation('open')

      // hides message after 5 seconds
      setTimeout(() => {
        this.setState({
          success: false,
          error: false,
        })
        $('#successModalNewsletter').foundation('close')
      }, 5000)

    }).catch((error) => {
      this.setState({
        loading: false,
        error: true,
      })
      setTimeout(() => {
        this.setState({
          error: false,
        })
      }, 7000)
    })
  }

  _closeModalSuccess() {
    $('#successModalNewsletter').foundation('close')
  }
  _handleNameBlur() {
    this.setState({ nameDirt: true, nameControl: true })
  }
  _handleEmailBlur() {
    this.setState({ emailDirt: true, emailControl: true })
  }
  _handlePhoneBlur() {
    this.setState({ phoneDirt: true, phoneControl: true })
  }

  render() {

    let nameValid
    let nameValid2

    let emailValid
    let emailValid2

    let phoneValid
    let phoneValid2

    if (this.state.nameDirt) {
      nameValid = (this.state.name.length >= 2) ? 'is-valid' : ''
    }
    if (this.state.nameControl) {
      nameValid2 = nameValid === '' ? 'has-error' : ''
    }

    if (this.state.emailDirt) {
      emailValid = (TOOLS.emailValid(this.state.email)) ? 'is-valid' : ''
    }
    if (this.state.emailControl) {
      emailValid2 = emailValid === '' ? 'has-error' : ''
    }

    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : ''
    }
    if (this.state.phoneControl) {
      phoneValid2 = phoneValid === '' ? 'has-error' : ''
    }

    const shouldShowTheNewsletter = () => {
      return !(
        this.props.location.pathname.includes('contato') ||
        this.props.location.pathname.includes('mapa-de-lojas') ||
        this.props.location.pathname.includes('erro-404') ||
        this.props.location.pathname.includes('/bairros') ||
        this.props.location.pathname.includes('casavivaz') ||
        this.props.location.pathname.includes('instituto-cyrela')
      )
    }

    const isProductPage = (
      this.props.location.pathname.includes('apartamento/') ||
      this.props.location.pathname.includes('vendedor')
    )

    let formValid = (nameValid === 'is-valid' && emailValid === 'is-valid') ? true : false

    return shouldShowTheNewsletter() ? (
      <section id='newsletter' className='newsletter clearfix' data-ga-name='section-newsletter' data-module='newsletter'>
        <div className={`grid-container mt2 mb4 ${this.props.prime ? 'prime' : '' }`}>
          <div className='grid-x grid-margin-x grid-margin-y align-middle'>
            <div className='cell medium-6 large-6'>
              <h2 className='h4'><strong>

                {this.props.location.advantages ?
                  <strong> Receba em primeira mão nossos principais lançamentos e novidades.</strong>
                  : <strong>Pode ter um Vivaz pertinho de você! Receba em primeira mão nossos principais lançamentos e novidades.</strong>}
              </strong></h2>
            </div>
            <div className='cell medium-6 large-5 large-offset-1'>

              <form onSubmit={(event) => this._handleSubmit(event)}>

                <div className={`field-group mb2 ${nameValid} ${nameValid2}`}>
                  <label>
                    <input
                      className='mb0'
                      type='text'
                      value={this.state.name}
                      onChange={(event) => this.setState({ nameDirt: true, name: event.target.value })}
                      onBlur={(e) => { handleBlurDatalayer(e, 'name', 'newsletter'); this._handleNameBlur() }}
                      maxLength='70'
                      placeholder='Qual é seu nome?'
                    />
                    <div className='text-small text-error ml1 mt1'>Preencha o nome, por favor</div>
                  </label>
                  <span className='icon mr1'>
                    <span className='field-icon'>
                      <Icon iconType='far' icon='user' size='sm' />
                    </span>
                    <span className='text-error'>
                      <Icon icon='times' size='sm' />
                    </span>
                    <span className='text-success'>
                      <Icon icon='check' size='sm' />
                    </span>
                  </span>
                </div>

                <div className={`field-group mb2 ${emailValid} ${emailValid2} ${nameValid === 'is-valid' ? '' : 'hidden'}`}>
                  <label>
                    <input
                      className='mb0'
                      type='email'
                      value={this.state.email}
                      onChange={(event) => this.setState({ emailDirt: true, email: event.target.value })}
                      onBlur={(e) => { handleBlurDatalayer(e, 'email', 'newsletter'); this._handleEmailBlur() }}
                      maxLength='70'
                      placeholder='Qual é seu e-mail?'
                    />
                    <div className='text-small text-error ml1 mt1'>Preencha o e-mail, por favor</div>
                  </label>
                  <span className='icon mr1'>
                    <span className='field-icon'>
                      <Icon icon='at' size='sm' />
                    </span>
                    <span className='text-error'>
                      <Icon icon='times' size='sm' />
                    </span>
                    <span className='text-success'>
                      <Icon icon='check' size='sm' />
                    </span>
                  </span>
                </div>

                <div className={`field-group mb2 ${phoneValid} ${phoneValid2} ${emailValid === 'is-valid' ? '' : 'hidden'}`}>
                  <label>
                    <MaskedInput
                      mask={TOOLS.cellphoneMask(this.state.phone)}
                      guide={false}
                      className='mb0'
                      type='tel'
                      value={this.state.phone}
                      onChange={(event) => this.setState({ phoneDirt: true, phone: event.target.value })}
                      onBlur={(e) => { handleBlurDatalayer(e, 'phone', 'newsletter'); this._handlePhoneBlur() }}
                      placeholder='Qual é o seu telefone (com DDD)?'
                    />
                    <div className='text-small text-error ml1 mt1'>Preencha o telefone, por favor</div>
                  </label>
                  <span className='icon mr1'>
                    <span className='field-icon'>
                      <Icon icon='phone' size='sm' />
                    </span>
                    <span className='text-error'>
                      <Icon icon='times' size='sm' />
                    </span>
                    <span className='text-success'>
                      <Icon icon='check' size='sm' />
                    </span>
                  </span>
                </div>

                <div className={`custom-checkbox ${emailValid === 'is-valid' ? '' : 'hidden'}`}>
                  <input id='whatsapp-field' type='checkbox' checked={this.state.warningWhatsapp} onChange={() => this.setState({ warningWhatsapp: !this.state.warningWhatsapp })} /><label htmlFor='whatsapp-field'>Prefiro que falem comigo pelo WhatsApp</label>
                </div>

                <div className={'mb2 mt2'}>
                  <label className='policies' htmlFor='privacy-field-newsletter'>Prezamos pela privacidade e a coleta dos seus dados pessoais atenderá as diretrizes da legislação aplicável. Para mais informações, acesse nosso{' '}
                    <a href='/termos-privacidade' title='Aviso de Privacidade' target='_blank' rel='noreferrer noopener'>Aviso de Privacidade</a>
                  </label>
                </div>

                <footer className='mt3 submit-container'>
                  <button className='button mb0 min-width' type='submit' disabled={this.state.loading || !formValid}>{this.state.loading ? 'Enviando...' : 'Cadastrar'}</button>
                </footer>

                {this.state.error &&
                  <div className='callout alert text-center mt4 mb0'>
                    <p>Infelizmente não foi possível cadastrar seus dados.</p>
                  </div>
                }
              </form>

              <div className='reveal tiny' id='successModalNewsletter' data-reveal>
                {this.state.hasEmail &&
                  <p className='text-center mt2'>Já pegamos seu contato! Logo menos um consultor treinado da Vivaz entrará em contato com você!</p>
                }
                {!this.state.hasEmail &&
                  <p className='text-center mt2'>Seus dados foram cadastrados.</p>
                }
                <button className='close-button' type='button' onClick={() => this._closeModalSuccess()}>
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>

            </div>
          </div>
        </div>

        {isProductPage ? (
          <div className='grid-container mt2 mb4 product-itbi' id='itbi-texto-legal'>
            <hr />
            <h3>*Condições ITBI e Registro Grátis</h3>
            <p>
              A Vendedora será responsável pelas despesas de ITBI e Registro quando a quitação da unidade ocorrer por meio de financiamento associativo, liberação de FGTS ou financiamento após o habite-se. Nos casos de quitação através das modalidades de proposta à vista, tabela direta, SFH ou aquisição por investidor, essas despesas ficarão sob responsabilidade do Comprador.
            </p>
            <p>
              <strong>Despesas para escritura no Cartório de Notas:</strong>
            </p>
            <p>
              As despesas relacionadas à lavratura da escritura pública serão de responsabilidade do Comprador.
            </p>
            <p>
            <strong>Despesas para emissão do contrato de financiamento no Banco:</strong>
            </p>
            <p>
            Os custos cobrados pelo agente financeiro para emissão do contrato de financiamento serão de responsabilidade do Comprador.
           </p>
          </div>
        ) : ''}
      </section>
    ) : ''
  }
}

const mapStateToProps = state => {
  return {
    region: state.shared.region,
    regions: state.shared.regions,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Newsletter)



// WEBPACK FOOTER //
// ./src/components/children/Newsletter.js